import {useQuery} from 'react-query'
import {useMemo} from 'react'
import {Get} from '../../../../../setup'
import {SAVTicketType, useSAV} from '../../../../@types'
import {useNotifications} from '../../../../@contexts'

const TICKETS_DETAILS = process.env.REACT_APP_SAV_TICKETS_DETAILS || 'sav/detail-ticket/'

type Props = {
    id: string;
};

export const useTicketDetails = ({id}: Props) => {

    const {refreshNotifications} = useNotifications()
    const {reloadKey, status} = useSAV()
    const endpoint = useMemo(() => `${TICKETS_DETAILS}${id}`, [id])

    const {data, isLoading, isFetching, isError} = useQuery(
        [`TICKET_${id}`, id, reloadKey],
        () => Get<{ticket: SAVTicketType}>({endpoint}),
        {
            staleTime: 60000,
            cacheTime: 300000,
            retry: 2,
            select: ({ticket}) => ticket,
            onSuccess: refreshNotifications,
        },
    )

    const transformedTicket = useMemo(() => {
        if (!data) return null
        const matchedStatus = status.find((s) => s.name === data.status)
        return {...data, status: matchedStatus || {id: 0, name: data.status, color: 'default'}}
    }, [data, status])

    return {data: transformedTicket, isLoading, isFetching, isError}
}
